
import React, { useEffect } from 'react';


interface AdSenseWindow extends Window {
  adsbygoogle?: any[];
}

declare const window: AdSenseWindow;

const AdBanner: React.FC = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, []);

  return (
    <div className="ad-placeholder">
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client="ca-pub-6562372416534335"
           data-ad-slot="6967174773"
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  );
};

export default AdBanner;
